export default {
  // ============ WAREHOUSE ============
  'warehouse.category': 'Almacén',
  'warehouse.shortTitle': 'Guía del almacén de USFans',
  'warehouse.readTime': '8 min de lectura',
  'warehouse.toc': 'Tabla de contenidos',
  'warehouse.h1': 'Almacén de USFans: guía completa de almacenamiento, inspección y envío',
  'warehouse.lead': 'Aprende cómo funciona un almacén de USFans, qué implican el almacenamiento y la inspección, y cómo los productos llegan a tu puerta.',
  'warehouse.s1.title': '¿Qué es un almacén de USFans?',
  'warehouse.s1.p1': 'Un almacén de USFans es una instalación donde se reciben, almacenan y preparan los productos comprados para su envío. Actúa como punto central antes de enviar los pedidos.',
  'warehouse.s1.p2': 'Los almacenes ayudan a consolidar varias compras de distintos vendedores en un solo envío, lo que puede reducir el esfuerzo y el costo.',
  'warehouse.s2.title': 'Cómo funciona el almacenamiento',
  'warehouse.s2.p1': 'Cuando un producto llega al almacén, se registra, se etiqueta y se coloca. Cada paquete se rastrea para poder localizarlo rápidamente al momento del envío.',
  'warehouse.s2.p2': 'Los períodos y las políticas de almacenamiento pueden variar, por lo que conviene saber cuánto tiempo pueden permanecer los artículos y si hay tarifas.',
  'warehouse.s3.title': 'Inspección y consolidación',
  'warehouse.s3.p1': 'Muchos almacenes ofrecen inspección opcional, donde el personal revisa el estado del producto o confirma el contenido del paquete antes del envío.',
  'warehouse.s3.p2': 'La consolidación combina varios paquetes pequeños en una caja más grande, lo que a menudo reduce la cantidad de envíos y el costo total.',
  'warehouse.s4.title': 'Envío desde el almacén',
  'warehouse.s4.p1': 'Cuando los productos están listos, el almacén los prepara para el método de envío elegido. Etiquetas, documentos aduaneros y embalaje se gestionan antes de la salida.',
  'warehouse.s4.p2': 'El tiempo de entrega final depende del país de destino, el transportista y la velocidad de envío seleccionada.',
  'warehouse.s5.title': 'Almacén vs envío directo',
  'warehouse.s5.p1': 'La siguiente tabla compara el uso de un almacén con el envío directo para mostrar las principales diferencias.',
  'warehouse.table.c1': 'Aspecto',
  'warehouse.table.c2': 'Almacén',
  'warehouse.table.c3': 'Envío directo',
  'warehouse.table.c4': 'Ideal para',
  'warehouse.table.r1c1': 'Varios pedidos',
  'warehouse.table.r1c2': 'Puede consolidar',
  'warehouse.table.r1c3': 'Se envían por separado',
  'warehouse.table.r1c4': 'Ahorro combinado',
  'warehouse.table.r2c1': 'Inspección',
  'warehouse.table.r2c2': 'A menudo disponible',
  'warehouse.table.r2c3': 'Normalmente no',
  'warehouse.table.r2c4': 'Mayor confianza',
  'warehouse.table.r3c1': 'Tiempo de almacenamiento',
  'warehouse.table.r3c2': 'Retiene artículos',
  'warehouse.table.r3c3': 'Sin retención',
  'warehouse.table.r3c4': 'Envío diferido',
  'warehouse.table.r4c1': 'Complejidad',
  'warehouse.table.r4c2': 'Más pasos',
  'warehouse.table.r4c3': 'Menos pasos',
  'warehouse.table.r4c4': 'Diferentes necesidades',
  'warehouse.s6.title': 'Tarifas y tiempos del almacén',
  'warehouse.s6.p1': 'Los servicios de almacén pueden implicar tarifas por almacenamiento, consolidación, inspección o reempaque. Varían, así que revisa el precio actual.',
  'warehouse.s6.p2': 'El tiempo también depende de la rapidez con la que el almacén procesa los paquetes entrantes y de su carga de trabajo.',
  'warehouse.s7.title': 'Seguridad del almacén',
  'warehouse.s7.p1': 'Usa solo servicios de almacén de confianza y verifica siempre la dirección y los detalles de envío antes de confirmar.',
  'warehouse.s7.p2': 'Ten cuidado con quienes pidan pagos fuera de la plataforma oficial y guarda los números de seguimiento.',
  'warehouse.conclusion.title': 'Reflexiones finales',
  'warehouse.conclusion.p1': 'Un almacén de USFans puede facilitar las compras múltiples al almacenar, inspeccionar y consolidar artículos antes del envío.',
  'warehouse.conclusion.p2': 'Revisa siempre las tarifas, políticas y prácticas de seguridad para usar los servicios con confianza.',
  'warehouse.cta': 'Explorar la tienda completa',
  'warehouse.backHome': 'Volver a la página de inicio',

  // ============ LEGIT ============
  'legit.category': 'Legitimidad',
  'legit.shortTitle': '¿USFans es legítimo?',
  'legit.readTime': '7 min de lectura',
  'legit.toc': 'Tabla de contenidos',
  'legit.h1': '¿USFans es legítimo? Seguridad, confianza y qué comprobar',
  'legit.lead': 'Comprende cómo evaluar la legitimidad de USFans, qué señales de confianza buscar y cómo protegerte.',
  'legit.s1.title': '¿Qué significa legitimidad aquí?',
  'legit.s1.p1': 'La legitimidad significa si un servicio opera con transparencia, cumple sus promesas y protege a sus usuarios. Es una cuestión de confianza construida con el tiempo.',
  'legit.s1.p2': 'Ningún recurso independiente debe afirmar que un servicio de terceros es totalmente seguro. Enfócate en señales verificables y en tu propia investigación.',
  'legit.s2.title': 'Señales de confianza',
  'legit.s2.p1': 'Información de contacto clara, políticas transparentes, datos de empresa verificables y soporte receptivo son señales positivas.',
  'legit.s2.p2': 'Las experiencias reales de usuarios y las discusiones de terceros también ayudan, pero trata las opiniones individuales con cuidado.',
  'legit.s3.title': 'Señales de alerta comunes',
  'legit.s3.p1': 'La presión para actuar rápido, las solicitudes de pago fuera de canales oficiales y las políticas vagas son señales de advertencia comunes.',
  'legit.s3.p2': 'Las promesas demasiado buenas para ser verdad o las solicitudes de contraseñas siempre deben tratarse con cautela.',
  'legit.s4.title': 'Cómo verificar de forma independiente',
  'legit.s4.p1': 'Consulta las fuentes oficiales directamente, revisa los términos y confirma detalles importantes como precios y envío antes de comprometerte.',
  'legit.s4.p2': 'La verificación independiente es la mejor protección, porque la información de terceros puede cambiar.',
  'legit.s5.title': 'Factores de confianza comparados',
  'legit.s5.p1': 'La siguiente tabla resume los factores clave para juzgar si un servicio parece confiable.',
  'legit.table.c1': 'Factor',
  'legit.table.c2': 'Señal positiva',
  'legit.table.c3': 'Señal de alerta',
  'legit.table.c4': 'Qué hacer',
  'legit.table.r1c1': 'Contacto',
  'legit.table.r1c2': 'Claro y accesible',
  'legit.table.r1c3': 'Falta o es vago',
  'legit.table.r1c4': 'Verifica por tu cuenta',
  'legit.table.r2c1': 'Políticas',
  'legit.table.r2c2': 'Términos transparentes',
  'legit.table.r2c3': 'Condiciones ocultas',
  'legit.table.r2c4': 'Lee con cuidado',
  'legit.table.r3c1': 'Pagos',
  'legit.table.r3c2': 'Canales oficiales',
  'legit.table.r3c3': 'Solicitudes externas',
  'legit.table.r3c4': 'Evita y reporta',
  'legit.table.r4c1': 'Soporte',
  'legit.table.r4c2': 'Ayuda receptiva',
  'legit.table.r4c3': 'Sin respuesta',
  'legit.table.r4c4': 'Prueba antes de comprar',
  'legit.s6.title': 'Seguridad de pagos y cuenta',
  'legit.s6.p1': 'Paga solo por canales oficiales y seguros y nunca compartas tu contraseña, códigos de verificación ni datos de cuenta.',
  'legit.s6.p2': 'Usa contraseñas fuertes y únicas y activa las opciones de seguridad adicionales que ofrezca la plataforma.',
  'legit.s7.title': 'Consideraciones de privacidad',
  'legit.s7.p1': 'Ten en cuenta la información personal que compartes y evita ingresar datos sensibles en páginas desconocidas.',
  'legit.s7.p2': 'Este recurso independiente no requiere tu información personal para navegar.',
  'legit.conclusion.title': 'Reflexiones finales',
  'legit.conclusion.p1': 'Determinar la legitimidad requiere una investigación equilibrada e independiente, no depender de una sola fuente.',
  'legit.conclusion.p2': 'Mantente alerta, verifica los detalles por tu cuenta y usa canales oficiales.',
  'legit.cta': 'Explorar la tienda completa',
  'legit.backHome': 'Volver a la página de inicio',

  // ============ CREATOR DIRECTORY ============
  'creator.category': 'Creadores',
  'creator.shortTitle': 'Guía del directorio de creadores de USFans',
  'creator.readTime': '7 min de lectura',
  'creator.toc': 'Tabla de contenidos',
  'creator.h1': 'Directorio de creadores de USFans: cómo encontrar y explorar creadores',
  'creator.lead': 'Aprende cómo funcionan los directorios de creadores, cómo encontrar creadores específicos y cómo explorar perfiles de forma eficiente.',
  'creator.s1.title': '¿Qué es un directorio de creadores?',
  'creator.s1.p1': 'Un directorio de creadores es una lista estructurada de creadores, organizada por categoría, nombre o estado, para facilitar el descubrimiento.',
  'creator.s1.p2': 'Los directorios te permiten revisar muchos perfiles en un solo lugar en lugar de buscar página por página.',
  'creator.s2.title': 'Cómo explorar el directorio',
  'creator.s2.p1': 'Empieza con una categoría que te interese y luego revisa las entradas individuales para entender qué ofrece cada creador.',
  'creator.s2.p2': 'Los filtros y la búsqueda pueden acotar los resultados por nombre o tema, ayudándote a enfocarte en los perfiles más relevantes.',
  'creator.s3.title': 'Leer un perfil de creador',
  'creator.s3.p1': 'Un perfil suele incluir el nombre, la categoría, un enlace o referencia, el estado y la fecha de la última actualización.',
  'creator.s3.p2': 'Enfócate en entradas activas y actualizadas recientemente, y verifica los detalles importantes directamente.',
  'creator.s4.title': 'Consejos de descubrimiento',
  'creator.s4.p1': 'Comienza de forma amplia y luego acota. Explora una categoría primero y luego busca creadores que coincidan con tus intereses.',
  'creator.s4.p2': 'Tomar notas mientras navegas te ayuda a comparar creadores y volver a los más prometedores.',
  'creator.s5.title': 'Directorio vs hoja de cálculo',
  'creator.s5.p1': 'La siguiente tabla compara un directorio con una vista de hoja de cálculo para aclarar cuándo es más útil cada uno.',
  'creator.table.c1': 'Aspecto',
  'creator.table.c2': 'Directorio',
  'creator.table.c3': 'Hoja de cálculo',
  'creator.table.c4': 'Ideal para',
  'creator.table.r1c1': 'Diseño',
  'creator.table.r1c2': 'Páginas por categoría',
  'creator.table.r1c3': 'Filas y columnas',
  'creator.table.r1c4': 'Navegación distinta',
  'creator.table.r2c1': 'Descubrimiento',
  'creator.table.r2c2': 'Navegar por tema',
  'creator.table.r2c3': 'Escanear y comparar',
  'creator.table.r2c4': 'Ambos útiles',
  'creator.table.r3c1': 'Actualización',
  'creator.table.r3c2': 'Depende del mantenimiento',
  'creator.table.r3c3': 'Depende del mantenimiento',
  'creator.table.r3c4': 'Verifica manualmente',
  'creator.table.r4c1': 'Curva de aprendizaje',
  'creator.table.r4c2': 'Muy baja',
  'creator.table.r4c3': 'Baja',
  'creator.table.r4c4': 'Fácil de empezar',
  'creator.s6.title': 'Calidad de datos y verificación',
  'creator.s6.p1': 'Los directorios mantenidos por la comunidad pueden contener entradas desactualizadas, así que verifica siempre los enlaces y detalles por tu cuenta.',
  'creator.s6.p2': 'Trata con cuidado cualquier enlace que pida información personal o pagos y usa fuentes oficiales de confianza.',
  'creator.s7.title': 'Privacidad al navegar',
  'creator.s7.p1': 'Evita compartir datos sensibles en páginas desconocidas y usa sitios oficiales para cuentas y compras.',
  'creator.s7.p2': 'Este recurso independiente te permite explorar guías y directorios sin proporcionar datos personales.',
  'creator.conclusion.title': 'Reflexiones finales',
  'creator.conclusion.p1': 'Un directorio de creadores es un punto de partida cómodo para descubrir y comparar creadores.',
  'creator.conclusion.p2': 'Combina la navegación del directorio con la verificación independiente para obtener la imagen más precisa.',
  'creator.cta': 'Explorar la tienda completa',
  'creator.backHome': 'Volver a la página de inicio',

  // ============ SPREADSHEET SEARCH ============
  'search.category': 'Búsqueda',
  'search.shortTitle': 'Guía de búsqueda en la hoja de cálculo de USFans',
  'search.readTime': '6 min de lectura',
  'search.toc': 'Tabla de contenidos',
  'search.h1': 'Búsqueda en la hoja de cálculo de USFans: encuentra lo que necesitas rápido',
  'search.lead': 'Aprende consejos prácticos para buscar en una hoja de cálculo de USFans, usar filtros y acotar resultados rápidamente.',
  'search.s1.title': 'Por qué importa la búsqueda',
  'search.s1.p1': 'Una hoja de cálculo bien organizada puede contener muchas entradas, así que saber buscar te ayuda a encontrar lo que necesitas sin revisarlo todo.',
  'search.s1.p2': 'Buenos hábitos de búsqueda convierten un recurso grande en una herramienta rápida y enfocada.',
  'search.s2.title': 'Empezar por las categorías',
  'search.s2.p1': 'Comienza eligiendo la categoría que mejor se ajuste a lo que buscas y luego explora las entradas dentro de ella.',
  'search.s2.p2': 'Este primer paso simple elimina la mayoría de los resultados irrelevantes antes de empezar a leer.',
  'search.s3.title': 'Usar filtros y palabras clave',
  'search.s3.p1': 'Usa filtros para acotar por nombre, estado o fecha de actualización, y usa palabras clave cortas y específicas.',
  'search.s3.p2': 'Si una palabra clave es demasiado estrecha y no devuelve nada, prueba un término más amplio y acota gradualmente.',
  'search.s4.title': 'Leer los resultados',
  'search.s4.p1': 'Presta atención al estado y a la información de actualización para priorizar las entradas activas y recientes.',
  'search.s4.p2': 'Abre los resultados prometedores en una pestaña nueva para comparar varias entradas sin perder tu lugar.',
  'search.s5.title': 'Enfoques de búsqueda comparados',
  'search.s5.p1': 'La siguiente tabla compara enfoques de búsqueda comunes para ayudarte a elegir el correcto.',
  'search.table.c1': 'Enfoque',
  'search.table.c2': 'Cómo funciona',
  'search.table.c3': 'Fortaleza',
  'search.table.c4': 'Usar cuando',
  'search.table.r1c1': 'Por categoría',
  'search.table.r1c2': 'Explorar un grupo',
  'search.table.r1c3': 'Descubrimiento amplio',
  'search.table.r1c4': 'Explorar temas',
  'search.table.r2c1': 'Por palabra clave',
  'search.table.r2c2': 'Coincidir un término',
  'search.table.r2c3': 'Acotar rápido',
  'search.table.r2c4': 'Nombres conocidos',
  'search.table.r3c1': 'Por estado',
  'search.table.r3c2': 'Filtrar activos',
  'search.table.r3c3': 'Resultados frescos',
  'search.table.r3c4': 'Priorizar actualizaciones',
  'search.table.r4c1': 'Por fecha',
  'search.table.r4c2': 'Ordenar por actualización',
  'search.table.r4c3': 'Solo recientes',
  'search.table.r4c4': 'Verificar actualidad',
  'search.s6.title': 'Errores comunes de búsqueda',
  'search.s6.p1': 'Usar palabras clave demasiado específicas, ignorar los filtros y saltarse el estado son errores comunes que ralentizan la búsqueda.',
  'search.s6.p2': 'Empieza amplio, aplica filtros gradualmente y revisa siempre la fecha de actualización.',
  'search.s7.title': 'Seguridad en la búsqueda',
  'search.s7.p1': 'Ten cuidado con resultados que redirigen a páginas desconocidas y nunca ingreses datos personales o pagos en sitios no confiables.',
  'search.s7.p2': 'Usa fuentes conocidas y oficiales y verifica los detalles importantes por tu cuenta.',
  'search.conclusion.title': 'Reflexiones finales',
  'search.conclusion.p1': 'Una búsqueda eficaz convierte una hoja de cálculo de USFans en un recurso rápido y enfocado.',
  'search.conclusion.p2': 'Usa categorías, filtros e información de estado juntos para encontrar lo que necesitas rápido y seguro.',
  'search.cta': 'Explorar la tienda completa',
  'search.backHome': 'Volver a la página de inicio',

  // ============ SAFETY ============
  'safety.category': 'Seguridad',
  'safety.shortTitle': 'Centro de seguridad de USFans',
  'safety.readTime': '8 min de lectura',
  'safety.toc': 'Tabla de contenidos',
  'safety.h1': 'Centro de seguridad de USFans: protege tu cuenta y tus pagos',
  'safety.lead': 'Orientación práctica sobre seguridad de la cuenta, pagos, conciencia sobre phishing y protección de la privacidad.',
  'safety.s1.title': 'Por qué importa la seguridad',
  'safety.s1.p1': 'Los servicios en línea implican información personal y pagos, por lo que los hábitos básicos de seguridad protegen tu cuenta y tu dinero.',
  'safety.s1.p2': 'La mayoría de los problemas se pueden evitar con unas pocas precauciones sencillas y constantes.',
  'safety.s2.title': 'Conceptos básicos de seguridad de la cuenta',
  'safety.s2.p1': 'Usa una contraseña fuerte y única para cada servicio y nunca reutilices la misma en distintas plataformas.',
  'safety.s2.p2': 'Activa las opciones de seguridad adicionales que ofrezca la plataforma y mantén actualizados tus datos de recuperación.',
  'safety.s3.title': 'Seguridad en los pagos',
  'safety.s3.p1': 'Paga solo por canales oficiales y seguros y confirma siempre los detalles antes de completar una transacción.',
  'safety.s3.p2': 'Nunca compartas información de pago, códigos de verificación ni contraseñas con quien te contacte de forma inesperada.',
  'safety.s4.title': 'Conciencia sobre phishing y estafas',
  'safety.s4.p1': 'Los mensajes de phishing suelen imitar un servicio real y te presionan para actuar rápido o hacer clic en un enlace. Verifica al remitente.',
  'safety.s4.p2': 'Desconfía de ofertas demasiado buenas para ser verdad y de solicitudes para mover pagos a canales no oficiales.',
  'safety.s5.title': 'Riesgo vs protección',
  'safety.s5.p1': 'La siguiente tabla empareja riesgos comunes con protecciones sencillas.',
  'safety.table.c1': 'Riesgo',
  'safety.table.c2': 'Ejemplo',
  'safety.table.c3': 'Protección',
  'safety.table.c4': 'Prioridad',
  'safety.table.r1c1': 'Robo de cuenta',
  'safety.table.r1c2': 'Contraseña débil',
  'safety.table.r1c3': 'Contraseña única',
  'safety.table.r1c4': 'Alta',
  'safety.table.r2c1': 'Fraude de pago',
  'safety.table.r2c2': 'Solicitud externa',
  'safety.table.r2c3': 'Canales oficiales',
  'safety.table.r2c4': 'Alta',
  'safety.table.r3c1': 'Phishing',
  'safety.table.r3c2': 'Mensaje falso',
  'safety.table.r3c3': 'Verificar remitente',
  'safety.table.r3c4': 'Alta',
  'safety.table.r4c1': 'Exposición de datos',
  'safety.table.r4c2': 'Compartir de más',
  'safety.table.r4c3': 'Limitar lo compartido',
  'safety.table.r4c4': 'Media',
  'safety.s6.title': 'Verificación de datos',
  'safety.s6.p1': 'Verifica siempre enlaces, precios y políticas directamente en el sitio oficial antes de decidir o pagar.',
  'safety.s6.p2': 'La información de terceros puede cambiar, por lo que la verificación independiente es esencial.',
  'safety.s7.title': 'Protección de la privacidad',
  'safety.s7.p1': 'Ten en cuenta lo que compartes en línea y evita ingresar datos sensibles en páginas desconocidas.',
  'safety.s7.p2': 'Este recurso independiente no pide tu información personal para navegar.',
  'safety.conclusion.title': 'Reflexiones finales',
  'safety.conclusion.p1': 'Unos pocos hábitos de seguridad constantes protegen tu cuenta, pagos y privacidad.',
  'safety.conclusion.p2': 'Mantente alerta, verifica por tu cuenta y usa canales oficiales para actividades sensibles.',
  'safety.cta': 'Explorar la tienda completa',
  'safety.backHome': 'Volver a la página de inicio',

  // ============ FAQ ============
  'faq.category': 'FAQ',
  'faq.shortTitle': 'FAQ completa de USFans',
  'faq.readTime': '6 min de lectura',
  'faq.toc': 'Tabla de contenidos',
  'faq.h1': 'FAQ de USFans: respuestas a preguntas comunes',
  'faq.lead': 'Respuestas claras a las preguntas más comunes sobre USFans, su hoja de cálculo, envíos, cupones y seguridad.',
  'faq.s1.title': 'Primeros pasos',
  'faq.s1.p1': 'Si eres nuevo en USFans, empieza por entender qué es y cómo se organizan sus recursos antes de profundizar.',
  'faq.s1.p2': 'Las guías de este sitio explican los conceptos básicos paso a paso para que formes una imagen clara rápidamente.',
  'faq.s2.title': 'Sobre la hoja de cálculo',
  'faq.s2.p1': 'La hoja de cálculo de USFans es un recurso organizado que reúne listas de creadores, categorías y enlaces útiles.',
  'faq.s2.p2': 'Está diseñada para facilitar el descubrimiento y la comparación frente a buscar en muchas páginas.',
  'faq.s3.title': 'Sobre el envío',
  'faq.s3.p1': 'Los costos de envío dependen de factores como el destino, el peso, el transportista y la velocidad, y pueden cambiar.',
  'faq.s3.p2': 'Confirma siempre los detalles de envío actuales en el sitio oficial antes de hacer un pedido.',
  'faq.s4.title': 'Sobre cupones y descuentos',
  'faq.s4.p1': 'Los cupones y códigos pueden cambiar o vencer, así que revisa las ofertas actuales en la tienda oficial.',
  'faq.s4.p2': 'Usa solo códigos de fuentes confiables y evita los que parezcan sospechosos o demasiado buenos.',
  'faq.s5.title': 'Preguntas comunes comparadas',
  'faq.s5.p1': 'La siguiente tabla resume algunas preguntas comunes y sus respuestas cortas.',
  'faq.table.c1': 'Pregunta',
  'faq.table.c2': 'Respuesta corta',
  'faq.table.c3': 'Guía relacionada',
  'faq.table.c4': 'Dónde verificar',
  'faq.table.r1c1': '¿Qué es USFans?',
  'faq.table.r1c2': 'Un recurso de compras',
  'faq.table.r1c3': 'Guía para principiantes',
  'faq.table.r1c4': 'Sitio oficial',
  'faq.table.r2c1': '¿Cómo se calcula el envío?',
  'faq.table.r2c2': 'Varios factores',
  'faq.table.r2c3': 'Guía de envío',
  'faq.table.r2c4': 'Sitio oficial',
  'faq.table.r3c1': '¿Los cupones son reales?',
  'faq.table.r3c2': 'Varía según la oferta',
  'faq.table.r3c3': 'Guía de cupones',
  'faq.table.r3c4': 'Tienda oficial',
  'faq.table.r4c1': '¿Es seguro?',
  'faq.table.r4c2': 'Usa precauciones',
  'faq.table.r4c3': 'Centro de seguridad',
  'faq.table.r4c4': 'Verificación independiente',
  'faq.s6.title': 'Solución de problemas',
  'faq.s6.p1': 'Si un enlace no funciona o la información está desactualizada, revisa el sitio oficial y busca los detalles más recientes.',
  'faq.s6.p2': 'Para problemas de cuenta o pagos, contacta al soporte oficial solo por canales verificados.',
  'faq.s7.title': 'Más ayuda',
  'faq.s7.p1': 'Explora las guías relacionadas de este sitio para explicaciones más profundas de cada tema.',
  'faq.s7.p2': 'Recuerda que este es un recurso independiente, así que confirma siempre los detalles importantes.',
  'faq.conclusion.title': 'Reflexiones finales',
  'faq.conclusion.p1': 'La mayoría de las preguntas tienen una respuesta simple una vez que sabes dónde buscar.',
  'faq.conclusion.p2': 'Usa las guías y las fuentes oficiales juntas para obtener información precisa y actual.',
  'faq.cta': 'Explorar la tienda completa',
  'faq.backHome': 'Volver a la página de inicio',

  // ============ ALTERNATIVES ============
  'alternatives.category': 'Alternativas',
  'alternatives.shortTitle': 'Alternativas a USFans',
  'alternatives.readTime': '7 min de lectura',
  'alternatives.toc': 'Tabla de contenidos',
  'alternatives.h1': 'Alternativas a USFans: cómo comparar tus opciones',
  'alternatives.lead': 'Aprende a evaluar alternativas a USFans y a comparar servicios según tus necesidades.',
  'alternatives.s1.title': 'Por qué considerar alternativas',
  'alternatives.s1.p1': 'Distintos servicios ofrecen distintas funciones, precios y opciones de envío, así que comparar alternativas puede ayudarte a encontrar el mejor ajuste.',
  'alternatives.s1.p2': 'Entender qué es lo más importante para ti hace que cualquier comparación sea más útil.',
  'alternatives.s2.title': 'Qué comparar',
  'alternatives.s2.p1': 'Enfócate en los factores que más te afectan, como el costo de envío, el tiempo de entrega, las categorías y la facilidad de uso.',
  'alternatives.s2.p2': 'Las políticas, la calidad del soporte y la transparencia también importan y revelan mucho sobre un servicio.',
  'alternatives.s3.title': 'Envío y precios',
  'alternatives.s3.p1': 'Compara métodos de envío, tiempos estimados y tarifas adicionales, ya que afectan directamente el costo final.',
  'alternatives.s3.p2': 'Los precios pueden cambiar, así que confirma las tarifas actuales directamente en lugar de depender de comparaciones antiguas.',
  'alternatives.s4.title': 'Confianza y soporte',
  'alternatives.s4.p1': 'Busca información de contacto clara, políticas transparentes y soporte receptivo al evaluar cualquier alternativa.',
  'alternatives.s4.p2': 'Las reseñas independientes y las discusiones de la comunidad ayudan, pero verifica siempre las afirmaciones importantes.',
  'alternatives.s5.title': 'Marco de comparación',
  'alternatives.s5.p1': 'La siguiente tabla ofrece un marco simple para comparar servicios lado a lado.',
  'alternatives.table.c1': 'Factor',
  'alternatives.table.c2': 'Qué revisar',
  'alternatives.table.c3': 'Por qué importa',
  'alternatives.table.c4': 'Cómo verificar',
  'alternatives.table.r1c1': 'Envío',
  'alternatives.table.r1c2': 'Costo y velocidad',
  'alternatives.table.r1c3': 'Afecta el precio total',
  'alternatives.table.r1c4': 'Tarifas oficiales',
  'alternatives.table.r2c1': 'Categorías',
  'alternatives.table.r2c2': 'Artículos disponibles',
  'alternatives.table.r2c3': 'Se ajusta a tus necesidades',
  'alternatives.table.r2c4': 'Explora la tienda',
  'alternatives.table.r3c1': 'Políticas',
  'alternatives.table.r3c2': 'Términos y tarifas',
  'alternatives.table.r3c3': 'Evitar sorpresas',
  'alternatives.table.r3c4': 'Lee los términos',
  'alternatives.table.r4c1': 'Soporte',
  'alternatives.table.r4c2': 'Capacidad de respuesta',
  'alternatives.table.r4c3': 'Tranquilidad',
  'alternatives.table.r4c4': 'Prueba el contacto',
  'alternatives.s6.title': 'Evitar el sesgo',
  'alternatives.s6.p1': 'Cada servicio tiene fortalezas y debilidades, así que intenta sopesarlas de forma objetiva.',
  'alternatives.s6.p2': 'Busca patrones en varias fuentes y verifica los hechos directamente antes de sacar conclusiones.',
  'alternatives.s7.title': 'Mantenerte seguro',
  'alternatives.s7.p1': 'Aplica los mismos hábitos de seguridad a cualquier servicio: usa canales oficiales, verifica detalles y protege tu cuenta y pagos.',
  'alternatives.s7.p2': 'Ten especial cuidado con alternativas de las que no has oído hablar antes.',
  'alternatives.conclusion.title': 'Reflexiones finales',
  'alternatives.conclusion.p1': 'Comparar alternativas con cuidado te ayuda a elegir el servicio que mejor se ajusta a tus necesidades.',
  'alternatives.conclusion.p2': 'Enfócate en los factores que más importan y verifica siempre la información actual.',
  'alternatives.cta': 'Explorar la tienda completa',
  'alternatives.backHome': 'Volver a la página de inicio',

  // ============ SHIPPING OPTIONS ============
  'shippingopts.category': 'Envío',
  'shippingopts.shortTitle': 'Guía de opciones de envío de USFans',
  'shippingopts.readTime': '7 min de lectura',
  'shippingopts.toc': 'Tabla de contenidos',
  'shippingopts.h1': 'Opciones de envío de USFans: métodos, entrega y envío internacional',
  'shippingopts.lead': 'Aprende sobre las distintas opciones de envío, cómo varían los tiempos de entrega y qué saber sobre el envío internacional.',
  'shippingopts.s1.title': 'Entender las opciones de envío',
  'shippingopts.s1.p1': 'Las opciones de envío suelen diferir en velocidad, transportista y costo, y la elección correcta depende de cuán rápido necesitas tu pedido.',
  'shippingopts.s1.p2': 'Los métodos más rápidos suelen costar más, mientras que los más lentos pueden ahorrar dinero si no tienes prisa.',
  'shippingopts.s2.title': 'Tiempos de entrega',
  'shippingopts.s2.p1': 'El tiempo de entrega depende del destino, el transportista y la velocidad seleccionada, y las estimaciones pueden variar.',
  'shippingopts.s2.p2': 'Revisa siempre los tiempos de entrega estimados actuales en el sitio oficial antes de hacer un pedido.',
  'shippingopts.s3.title': 'Envío internacional',
  'shippingopts.s3.p1': 'Los pedidos internacionales pueden implicar aduanas, aranceles y manejo adicional, lo que afecta el costo y el tiempo.',
  'shippingopts.s3.p2': 'Entiende las reglas del país de destino y las posibles tarifas para evitar sorpresas.',
  'shippingopts.s4.title': 'Elegir el método correcto',
  'shippingopts.s4.p1': 'Equilibra costo, velocidad y seguimiento al elegir un método, y considera la consolidación si pides varios artículos.',
  'shippingopts.s4.p2': 'Los números de seguimiento te ayudan a seguir tu pedido y detectar rápidamente retrasos o problemas.',
  'shippingopts.s5.title': 'Métodos de envío comparados',
  'shippingopts.s5.p1': 'La siguiente tabla compara tipos comunes de métodos de envío y cuándo cada uno es una buena elección.',
  'shippingopts.table.c1': 'Método',
  'shippingopts.table.c2': 'Velocidad',
  'shippingopts.table.c3': 'Costo',
  'shippingopts.table.c4': 'Ideal para',
  'shippingopts.table.r1c1': 'Estándar',
  'shippingopts.table.r1c2': 'Más lento',
  'shippingopts.table.r1c3': 'Más bajo',
  'shippingopts.table.r1c4': 'Ahorrar dinero',
  'shippingopts.table.r2c1': 'Exprés',
  'shippingopts.table.r2c2': 'Más rápido',
  'shippingopts.table.r2c3': 'Más alto',
  'shippingopts.table.r2c4': 'Pedidos urgentes',
  'shippingopts.table.r3c1': 'Con seguimiento',
  'shippingopts.table.r3c2': 'Varía',
  'shippingopts.table.r3c3': 'Moderado',
  'shippingopts.table.r3c4': 'Tranquilidad',
  'shippingopts.table.r4c1': 'Consolidado',
  'shippingopts.table.r4c2': 'Depende',
  'shippingopts.table.r4c3': 'Puede ser más bajo',
  'shippingopts.table.r4c4': 'Varios artículos',
  'shippingopts.s6.title': 'Seguimiento de tu pedido',
  'shippingopts.s6.p1': 'Usa el número de seguimiento para monitorear el progreso y contacta al soporte por canales oficiales si hay un retraso.',
  'shippingopts.s6.p2': 'Guarda los números de seguimiento y las comunicaciones por si necesitas hacer seguimiento.',
  'shippingopts.s7.title': 'Seguridad en el envío',
  'shippingopts.s7.p1': 'Proporciona los datos de envío solo en plataformas oficiales y verifica cuidadosamente la dirección de destino.',
  'shippingopts.s7.p2': 'Ten cuidado con quienes pidan cambiar el destino fuera del proceso oficial.',
  'shippingopts.conclusion.title': 'Reflexiones finales',
  'shippingopts.conclusion.p1': 'Entender tus opciones de envío te ayuda a equilibrar costo, velocidad y confiabilidad.',
  'shippingopts.conclusion.p2': 'Confirma siempre las tarifas y tiempos de entrega actuales en el sitio oficial antes de ordenar.',
  'shippingopts.cta': 'Explorar la tienda completa',
  'shippingopts.backHome': 'Volver a la página de inicio',

  // ============ DISCOUNT CODE ============
  'discount.category': 'Descuentos',
  'discount.shortTitle': 'Guía de códigos de descuento de USFans',
  'discount.readTime': '6 min de lectura',
  'discount.toc': 'Tabla de contenidos',
  'discount.h1': 'Guía de códigos de descuento y promocionales de USFans',
  'discount.lead': 'Aprende cómo funcionan los códigos de descuento y promocionales, dónde encontrarlos y cómo evitar ofertas vencidas o sospechosas.',
  'discount.s1.title': 'Cómo funcionan los códigos de descuento',
  'discount.s1.p1': 'Un código de descuento es un texto corto que ingresas al pagar para aplicar una reducción, promoción u oferta especial.',
  'discount.s1.p2': 'Los códigos pueden estar ligados a artículos específicos, montos mínimos o períodos, así que sus términos varían.',
  'discount.s2.title': 'Dónde encontrar códigos',
  'discount.s2.p1': 'Los canales oficiales, como la propia tienda o sus páginas verificadas, son los lugares más confiables para encontrar ofertas actuales.',
  'discount.s2.p2': 'Confirma siempre que un código sea válido y actual antes de usarlo, ya que las ofertas cambian con frecuencia.',
  'discount.s3.title': 'Tipos de descuentos',
  'discount.s3.p1': 'Los tipos comunes incluyen descuentos porcentuales, reducciones de monto fijo y promociones de envío gratis o paquetes.',
  'discount.s3.p2': 'Entender el tipo te ayuda a estimar el ahorro real y comparar ofertas de forma justa.',
  'discount.s4.title': 'Evitar códigos vencidos o falsos',
  'discount.s4.p1': 'Los códigos pueden vencer o dejar de funcionar, así que pruébalos al pagar y evita los sospechosos.',
  'discount.s4.p2': 'Desconfía de ofertas demasiado buenas para ser verdad o que pidan visitar páginas no oficiales.',
  'discount.s5.title': 'Tipos de descuento comparados',
  'discount.s5.p1': 'La siguiente tabla resume los tipos comunes de descuento y qué revisar en cada uno.',
  'discount.table.c1': 'Tipo',
  'discount.table.c2': 'Cómo funciona',
  'discount.table.c3': 'Ideal para',
  'discount.table.c4': 'Qué revisar',
  'discount.table.r1c1': 'Porcentual',
  'discount.table.r1c2': 'Reduce un porcentaje',
  'discount.table.r1c3': 'Pedidos grandes',
  'discount.table.r1c4': 'Monto mínimo',
  'discount.table.r2c1': 'Monto fijo',
  'discount.table.r2c2': 'Reduce un valor',
  'discount.table.r2c3': 'Cualquier pedido',
  'discount.table.r2c4': 'Términos y vencimiento',
  'discount.table.r3c1': 'Envío gratis',
  'discount.table.r3c2': 'Exime el envío',
  'discount.table.r3c3': 'Ahorrar en la entrega',
  'discount.table.r3c4': 'Condiciones',
  'discount.table.r4c1': 'Paquete',
  'discount.table.r4c2': 'Descuenta un conjunto',
  'discount.table.r4c3': 'Varios artículos',
  'discount.table.r4c4': 'Artículos incluidos',
  'discount.s6.title': 'Maximizar el ahorro',
  'discount.s6.p1': 'Compara algunas ofertas activas, revisa los términos y combina descuentos solo donde la tienda lo permita.',
  'discount.s6.p2': 'Presta atención a los anuncios oficiales para aprovechar las promociones mientras sean válidas.',
  'discount.s7.title': 'Uso seguro de códigos',
  'discount.s7.p1': 'Aplica códigos solo en el pago oficial y nunca compartas datos de pago en páginas no oficiales.',
  'discount.s7.p2': 'Si un código pide datos personales o te redirige a otro lado, cierra la página y usa la tienda oficial.',
  'discount.conclusion.title': 'Reflexiones finales',
  'discount.conclusion.p1': 'Los códigos de descuento y promocionales pueden reducir tu total cuando entiendes sus términos y los usas de forma segura.',
  'discount.conclusion.p2': 'Usa fuentes oficiales y verifica las ofertas actuales antes de pagar.',
  'discount.cta': 'Explorar la tienda completa',
  'discount.backHome': 'Volver a la página de inicio',

  // ============ BEGINNER GUIDE ============
  'beginner.category': 'Principiante',
  'beginner.shortTitle': 'Guía para principiantes de USFans',
  'beginner.readTime': '8 min de lectura',
  'beginner.toc': 'Tabla de contenidos',
  'beginner.h1': 'Guía para principiantes de USFans: cómo empezar paso a paso',
  'beginner.lead': 'Una introducción amigable a USFans, que cubre lo básico, cómo funcionan los recursos y cómo empezar con seguridad.',
  'beginner.s1.title': 'Bienvenido a USFans',
  'beginner.s1.p1': 'USFans es un recurso de compras que muchas personas usan para explorar productos, categorías y creadores en un solo lugar.',
  'beginner.s1.p2': 'Esta guía para principiantes explica lo esencial para que puedas empezar a explorar con confianza.',
  'beginner.s2.title': 'Entender lo básico',
  'beginner.s2.p1': 'Antes de navegar, tómate un momento para entender cómo se organizan los recursos principales, como la hoja de cálculo y los directorios.',
  'beginner.s2.p2': 'Una visión clara facilita todo lo demás, desde buscar hasta comparar y pagar.',
  'beginner.s3.title': 'Explorar categorías',
  'beginner.s3.p1': 'Empieza con una categoría que te interese y explora los artículos y creadores dentro de ella a tu ritmo.',
  'beginner.s3.p2': 'En este sitio, el menú de categorías y los botones llevan directamente a las secciones correspondientes de la tienda principal.',
  'beginner.s4.title': 'Tomar tu primera decisión',
  'beginner.s4.p1': 'Compara algunas opciones, revisa los detalles de envío y lee las guías relevantes antes de tu primera elección.',
  'beginner.s4.p2': 'No hay prisa: tomarte tiempo para entender tus opciones lleva a mejores decisiones.',
  'beginner.s5.title': 'Primeros pasos comparados',
  'beginner.s5.p1': 'La siguiente tabla relaciona los primeros pasos comunes con los recursos que ayudan en cada uno.',
  'beginner.table.c1': 'Paso',
  'beginner.table.c2': 'Qué hacer',
  'beginner.table.c3': 'Guía útil',
  'beginner.table.c4': 'Consejo clave',
  'beginner.table.r1c1': 'Aprende lo básico',
  'beginner.table.r1c2': 'Lee una introducción',
  'beginner.table.r1c3': 'Esta guía',
  'beginner.table.r1c4': 'Tómatelo con calma',
  'beginner.table.r2c1': 'Explora categorías',
  'beginner.table.r2c2': 'Elige una categoría',
  'beginner.table.r2c3': 'Menú de categorías',
  'beginner.table.r2c4': 'Empieza amplio',
  'beginner.table.r3c1': 'Compara opciones',
  'beginner.table.r3c2': 'Revisa artículos',
  'beginner.table.r3c3': 'Tablas comparativas',
  'beginner.table.r3c4': 'Anota diferencias',
  'beginner.table.r4c1': 'Revisa el envío',
  'beginner.table.r4c2': 'Confirma costos',
  'beginner.table.r4c3': 'Guía de envío',
  'beginner.table.r4c4': 'Verifica oficial',
  'beginner.s6.title': 'Errores comunes de principiantes',
  'beginner.s6.p1': 'Apresurar decisiones, saltarse los detalles de envío e ignorar lo básico de seguridad son errores comunes.',
  'beginner.s6.p2': 'Ir más despacio, verificar la información y usar canales oficiales te ayuda a evitar la mayoría de los problemas.',
  'beginner.s7.title': 'Mantenerte seguro como principiante',
  'beginner.s7.p1': 'Usa contraseñas fuertes, paga solo por canales oficiales y ten cuidado con enlaces u ofertas desconocidas.',
  'beginner.s7.p2': 'Este recurso independiente es gratis y no pide tu información personal.',
  'beginner.conclusion.title': 'Reflexiones finales',
  'beginner.conclusion.p1': 'Empezar con USFans es sencillo una vez que entiendes lo básico y avanzas paso a paso.',
  'beginner.conclusion.p2': 'Usa las guías, explora las categorías y verifica siempre los detalles importantes por tu cuenta.',
  'beginner.cta': 'Explorar la tienda completa',
  'beginner.backHome': 'Volver a la página de inicio',
};